import React from 'react';

const Location = (props) => (
  <svg width="11" height="16" viewBox="0 0 11 16" fill="transparent" {...props}>
    <path
      d="M1.81066 3.6528C2.55555 2.36336 3.88609 1.59277 5.37589 1.59277C6.86568 1.59277 8.20136 2.36336 8.94112 3.6528C9.68601 4.94224 9.68601 6.4834 8.94112 7.77285L5.37589 13.9529L1.81066 7.77285C1.06576 6.4834 1.06576 4.94224 1.81066 3.6528Z"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M5.37559 7.27999C6.28066 7.27999 7.01436 6.54628 7.01436 5.64121C7.01436 4.73614 6.28066 4.00244 5.37559 4.00244C4.47052 4.00244 3.73682 4.73614 3.73682 5.64121C3.73682 6.54628 4.47052 7.27999 5.37559 7.27999Z"
      fill="white"
    />
  </svg>
);

export default Location;
